import {

    CORE_LOAD_ALL_ROOMTYPE_SUCCESS,
    CORE_LOAD_ALL_ROOMTYPE_REQUEST,

    CORE_LOAD_SEARCH_ROOMTYPE_REQUEST,
    CORE_LOAD_SEARCH_ROOMTYPE_SUCCESS,

    CORE_LOAD_ROOMTYPE_SUCCESS,
    CORE_LOAD_ROOMTYPE_REQUEST,
} from '../../types'

const initialState = []
export default {
    roomtypeInfo: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ROOMTYPE_REQUEST:
                return initialState
            case CORE_LOAD_ROOMTYPE_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return {}
            default:
                return state
        }
    },
    roomtype: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_ROOMTYPE_REQUEST:
            case CORE_LOAD_SEARCH_ROOMTYPE_REQUEST:
                return initialState
            case CORE_LOAD_ALL_ROOMTYPE_SUCCESS:
            case CORE_LOAD_SEARCH_ROOMTYPE_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return []
            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/features/roomType/reducer.js